import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { limitTypeQueryKeys, updateLimitType } from '../api/limitTypes.api';
import type { UpdateLimitTypePayload } from '../types/limitType.types';

interface UpdateLimitTypeArgs {
  id: number;
  payload: UpdateLimitTypePayload;
}

export function useUpdateLimitType(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateLimitTypeArgs) => updateLimitType(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: limitTypeQueryKeys.all() });
      toast.success('Limit updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update limit');
    },
  });
}
